import axios from 'axios';
import {
  isProduction,
  PROD_TRIDENT_API_URL,
  QA_TRIDENT_API_URL,
  RECORD_FINANCE_IDENTITY_PATH,
} from '../constants';
import { getBtIdToken } from './btCognitoToken';
import { isBoatTraderSource } from './portalBranding';

export type FinanceSubmissionType = 'lead' | 'application';

const RECORD_FINANCE_IDENTITY_TIMEOUT_MS = 5000;

async function postFinanceIdentity(submissionType: FinanceSubmissionType): Promise<void> {
  try {
    const token = await getBtIdToken();
    if (!token) return;
    const baseUrl = isProduction() ? PROD_TRIDENT_API_URL : QA_TRIDENT_API_URL;
    await axios.post(
      `${baseUrl}${RECORD_FINANCE_IDENTITY_PATH}`,
      { submissionType },
      {
        headers: { Authorization: `Bearer ${token}` },
        timeout: RECORD_FINANCE_IDENTITY_TIMEOUT_MS,
      }
    );
  } catch {
    console.warn('recordFinanceIdentity | request failed');
  }
}

export function recordFinanceIdentity(
  submissionType: FinanceSubmissionType,
  sourceId?: number | null
): void {
  try {
    if (!isBoatTraderSource(sourceId)) return;
    postFinanceIdentity(submissionType);
  } catch {
    console.warn('recordFinanceIdentity | request failed');
  }
}
